function makeid(length) {
  var result           = '';
  var letters          = 'abcdef';
  var lettersLength    = letters.length;
  var characters       = 'abcdef0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < 1; i++ ) {
    result += letters.charAt(Math.floor(Math.random() * lettersLength));
 }
  for ( var i = 0; i < length; i++ ) {
     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
//console.log(makeid(3));